export default[
    {
        show(row,extra){
            return(
                row.shbj==='1'
            )
        },
        tag:'my-tag',
        type:'primary',
        text(row){
            return '已提交待审核';
        }
    },{
        show(row,extra){
            return(
                row.shbj==='4'
            )
        },
        tag:'my-tag',
        type:'primary',
        text(row){
            return '监督待审核';
        }
    },{
        show(row,extra){
            return(
                row.shbj==='5'
            )
        },
        tag:'my-tag',
        type:'primary',
        text(row){
            return '交易中心待审核';
        }
    },{
        show(row,extra){
            return(
                row.shbj==='6'
            )
        },
        tag:'my-tag',
        type:'primary',
        text(row){
            return '待公共服务平台审核';
        }
    },{
        show(row,extra){
            return(
                row.shbj==='8'
            )
        },
        tag:'my-tag',
        type:'primary',
        text(row){
            return '待平台审核';
        }
    },{
        show(row,extra){
            return(
                row.shbj==='0'
            )
        },
        tag:'my-tag',
        type:'warning',
        text(row){
            return '未提交';
        }
    },{
        show(row,extra){
            return(
                row.shbj==='9'
            )
        },
        tag:'my-tag',
        type:'success',
        text(row){
            return '已发布';
        }
    }
    // ,{
    //     show(row,extra){
    //         return(
    //             row.shbj==='3'
    //         )
    //     },
    //     tag:'my-tag',
    //     type:'danger',
    //     text(row){
    //         return `退回：${row.by2}`;
    //     }
    // },
]